import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from '../../gameData.js';
import Cell from './cell.js';
import Tile from './tile.js';
import Phaser from 'phaser';
import ABCyaLib from '@abcya/abcya_lib';

export default class Grid extends AContainer {
  constructor(scene, randomizeSteps, scramblingIndicator) {
    super(scene);

    this.randomizeSteps = randomizeSteps;
    this.scramblingIndicator = scramblingIndicator;
    this.rows = [];
    this.nodes = [];
    this.bgs = [];
    this.allTiles = [];
    this.nodeInd = 0;

    this.initGrid();
    this.positionGrid();
  }

  initGrid() {
    // init cells
    let chars = 'a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z| | | | ';
    if(ABCyaLib.Environment.instance.locale === 'es-US'){
      chars = 'a|b|c|d|e|f|g|h|i|j|k|l|m|n|ñ|o|p|q|r|s|t|u|v|w|x|y|z| | | ';
      gameData.emptySpaces = 3;
    }
    if (gameData.gameMode === 'upper') {
      chars = chars.toUpperCase();
    }
    const charsArr = chars.split('|');
    const totalCols = 5;
    let row;
    let rowIndex = -1;
    for (let c = 0; c < charsArr.length; c++) {
      const colIndex = c % totalCols;
      if (colIndex === 0) {
        if (row != null) this.rows.push(row);

        // create new row
        row = [];
        rowIndex++;
      }

      const bgTile = this.scene.addImage(0, 0, `${gameData.gameStyle}_Tray`);
      const cell = new Cell(this.scene, gameData.gameStyle, false, charsArr[c], this.rows, colIndex, rowIndex, c);
      const tile = new Tile(this.scene, gameData.gameStyle, false, charsArr[c]);

      bgTile.setDepth(1);
      tile.setDepth(2);

      cell.setTile(tile);

      this.scene.addToParent(tile, this.scene);
      this.allTiles.push(tile);
      this.nodes.push(cell);
      this.bgs.push(bgTile);

      row.push(cell);
    }
    this.rows.push(row);
  }

  positionGrid() {
    // calculate adjacent cells
    for (let r = 0; r < this.rows.length; r++) {
      const row = this.rows[r];
      for (let c = 0; c < row.length; c++) {
        const cell = row[c]; // cell is a tile

        cell.y = 90 + (140 * r);
        cell.x = 105 + (140 * c);
      }
    }

    let adjX;
    let adjY;
    if (gameData.gameStyle === 'Clsc') {
      adjX = 0;
      adjY = 0;
    }
    else if (gameData.gameStyle === 'Camo') {
      adjX = 0;
      adjY = 0;
    }
    else if (gameData.gameStyle === 'Wood') {
      adjX = 0;
      adjY = 0;
    }
    else if (gameData.gameStyle === 'Sprng') {
      adjX = 7;
      adjY = 7;
    }
    else if (gameData.gameStyle === 'Wntr') {
      adjX = 6;
      adjY = 6;
    }
    else if (gameData.gameStyle === 'Atm') {
      adjX = 7;
      adjY = 0;
    }
    else if (gameData.gameStyle === 'Smr') {
      adjX = 7;
      adjY = 7;
    }
    else if (gameData.gameStyle === 'Spc') {
      adjX = 1;
      adjY = 0;
    }
    else if (gameData.gameStyle === 'Uncrn') {
      adjX = 1;
      adjY = 0;
    }
    else if (gameData.gameStyle === 'Neon') {
      adjX = 0;
      adjY = 0;
    }

    for (let r = 0; r < this.allTiles.length; r++) {
      this.allTiles[r].x = this.nodes[r].x;
      this.allTiles[r].y = this.nodes[r].y;
      this.bgs[r].x = this.nodes[r].x + adjX;
      this.bgs[r].y = this.nodes[r].y + adjY;
    }
  }

  randomizeGrid() {
    for (let r = 0; r < this.nodes.length; r++) {
      if (this.nodes[r].tile.char === ' ' || this.nodes[r].tile.char === '') {
        this.nodes[r].calculateAdjacentCells();

        this.nodes[r].swapRandomTile();
      }
    }
  }

  updateGrid() {
    gameData.shuffleCounter--;

    if (gameData.shuffleCounter > 0) {
      this.randomizeGrid();
    }
    else {
      this.checkScore();

      for (let r = 0; r < this.allTiles.length; r++) {
        if (this.allTiles[r].char === ' ' || this.allTiles[r].char === '') {
          this.scene.addTween(this.allTiles[r].keyBG, 250, { alpha: 0 }, Phaser.Math.Easing.Linear);
        }
      }

      this.scene.enableNav();
      this.scene.enableSwipe();
    }
  }

  checkScore(isInit) {
    gameData.score = 0;

    if (!isInit) {
      for (let r = 0; r < this.nodes.length; r++) {
        if (this.nodes[r].checkCorrect() === true) gameData.score++;
      }
    }

    if (gameData.score === 30) this.scene.gameOver();
  }

  cleanUp() {
    for (let r = 0; r < this.nodes.length; r++) {
      this.allTiles[r].destroy();
      this.nodes[r].destroy();
      this.bgs[r].destroy();
    }
  }
}